import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class AppointSingRecordAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getAppointSingRecordList', {
            url: '/admin/carol/index',
            name: 'list',
            label: '列表'
        }],
    ])

    // 会员管理列表 后台充值列表
    public getAppointSingRecordList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getAppointSingRecordList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


    

}